export const NO_CREDS = "<no-creds>";

export const isCredentialIdEmpty = (credentialId?: string): boolean =>
  credentialId === "" ||
  credentialId === undefined ||
  credentialId === NO_CREDS;
